import { IconButton, Tooltip } from '@material-ui/core'
import MapOutlinedIcon from '@material-ui/icons/MapOutlined'
import { memo, useEffect, useRef } from 'react'

import CustomControl from '../../custom-control'
import { useStyles } from './styles'

interface LayersButtonProps {
  anchorEl: HTMLElement | null
  setAnchorEl: (anchorEl: HTMLElement | null) => void
  placement?: 'topleft' | 'topright' | 'bottomleft' | 'bottomright'
  defaultOpen?: boolean
}

function LayersButton({
  anchorEl,
  setAnchorEl,
  placement = 'bottomright',
  defaultOpen = false,
}: LayersButtonProps) {
  const classes = useStyles()
  const iconButtonRef = useRef<HTMLButtonElement>(null)

  const handleLayersToggle = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  useEffect(() => {
    if (defaultOpen && iconButtonRef.current) {
      const timer = setTimeout(() => {
        setAnchorEl(iconButtonRef.current)
      }, 0)

      return () => clearTimeout(timer)
    }
  }, [defaultOpen, setAnchorEl])

  return (
    <CustomControl
      data-testid='layers-control'
      style={{
        overflow: 'hidden',
        border: 'none',
      }}
      position={placement}
    >
      <Tooltip
        title='Controlar camadas'
        placement='left'
        classes={{
          tooltip: classes.tooltip,
        }}
      >
        <IconButton
          ref={iconButtonRef}
          className={classes.layersToggleButton}
          onClick={handleLayersToggle}
          aria-label='Controlar camadas'
          size='small'
        >
          <MapOutlinedIcon />
        </IconButton>
      </Tooltip>
    </CustomControl>
  )
}

export default memo(LayersButton)
